<template>
  <div>
    <LoadingSpinner v-if="loading"/>

    <ProjectLeadList v-else :project="project" :users="users"/>
  </div>
</template>

<script>
import http from '@/http'
import ProjectLeadList from '../../../../components/Relations/ProjectLeads/Panels/List'
import LoadingSpinner from "../../../../components/Layout/LoadingSpinner.vue";

export default {
  components: {LoadingSpinner, ProjectLeadList},

  model: {
    prop: 'project'
  },

  props: {
    project: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      users: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/users', {page_size: 100}).then(response => {
        this.users = response.data.data

        this.loading = false
      })
    }
  }
}
</script>
